import React, { useContext, useEffect, useState } from 'react'
import HotelCard from '../cards/hotel'
import {
  filterHotels,
  sortByDate,
  sortByName,
  sortByPrice,
  sortByRandom,
  sortByRating,
} from '../../lib/helpers'
import classes from '../pages/destinations/destinations.module.scss'
import Button from '../button'
import moment from 'moment'
import { SearchContext } from '../../lib/context/search-context'
import config from '../../config'

const Sortable = ({
  hotels,
  sortBy,
  showMap,
  areas,
  types,
  activeTab,
  showFrom = false,
}) => {
  const [orderedHotels, setOrderedHotels] = useState(hotels)
  const { searchParams, setSearchParameters } = useContext(SearchContext)

  useEffect(() => {
    let filtered = []
    if (types.length > 0 || areas.length > 0 || activeTab) {
      filtered = filterHotels(hotels, areas, types, activeTab)
    } else {
      filtered = hotels
    }
    if (sortBy[0] === 'random') {
      filtered.sort(sortByDate)
    }
    if (sortBy[0] === 'rating') {
      filtered.sort(sortByRating)
    }
    if (sortBy[0] === 'price') {
      filtered.sort(sortByPrice)
    }
    if (sortBy[0] === 'alphabetical') {
      filtered.sort(sortByName)
    }
    if (sortBy[1] === 'desc') {
      filtered.reverse()
    }
    const notAvailable = filtered.filter((h) => h.basePrice === 0)
    const available = filtered.filter((h) => h.basePrice > 0)
    setOrderedHotels([...available, ...notAvailable])
  }, [sortBy, areas, types])

  const editSearch = () => {
    // setNewSearch(true)
  }

  const addOneWeek = () => {
    const newCheckIn = moment(searchParams.checkinDate).add(1, 'week')
    const newCheckout = moment(searchParams.checkoutDate).add(1, 'week')
    setSearchParameters(
      {
        ...searchParams,
        checkinDate: newCheckIn,
        checkoutDate: newCheckout,
      },
      0,
      config.cookieOptions
    )
    window.location.reload()
  }
  return (
    <>
      {orderedHotels.length > 0 &&
        orderedHotels.map((hotel, i) => {
          return (
            <React.Fragment key={i}>
              <HotelCard
                gallery={hotel.images.length > 0}
                hotel={hotel}
                id={hotel.slug}
                smallGallery={showMap}
                fromPrice={hotel.basePrice}
                landscape
                showFrom={showFrom}
              />
            </React.Fragment>
          )
        })}
      {orderedHotels.length === 0 && (
        <div className={classes.noResults}>
          <h2>0 Stays Found</h2>
          <p>
            Are your dates flexible? There maybe more results a week later...
          </p>
          <div className={classes.noResultsActions}>
            <Button width={'160'} color="blue" onClick={addOneWeek}>
              Show me + 1 week
            </Button>
            <p onClick={editSearch}>Edit my search</p>
          </div>
        </div>
      )}
    </>
  )
}
export default Sortable
